export type VideoPlatform = "youtube" | "instagram" | "tiktok" | "other";

export type Video = {
  id: string;
  title: string;
  platform: VideoPlatform;
  externalUrl: string;
  thumbnailUrl: string | null;
  description: string | null;
  publishedAt: string | null;
  viewCount: number;
  featured: boolean;
};

export type VideosResponse = {
  videos: Video[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
};

export type VideoSort = "recent" | "views";

export function formatViews(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(n >= 10_000 ? 0 : 1)}K`;
  return `${n}`;
}

export function formatPublished(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

const PLATFORM_LABEL: Record<VideoPlatform, string> = {
  youtube: "YouTube",
  instagram: "Instagram",
  tiktok: "TikTok",
  other: "Watch",
};

export function platformLabel(p: VideoPlatform): string {
  return PLATFORM_LABEL[p] ?? "Watch";
}
